import { keyStores } from 'near-api-js'

export const getConfig = (environment = 'testnet') => {
	switch (environment) {
		case 'mainnet':
			return {
				networkId: 'mainnet',
				keyStore: new keyStores.BrowserLocalStorageKeyStore(),
				nodeUrl: 'https://rpc.mainnet.near.org',
				walletUrl: 'https://wallet.mainnet.near.org',
				helperUrl: 'https://helper.mainnet.near.org',
				explorerUrl: 'https://explorer.mainnet.near.org',
			}
		case 'betanet':
			return {
				networkId: 'betanet',
				keyStore: new keyStores.BrowserLocalStorageKeyStore(),
				nodeUrl: 'https://rpc.betanet.near.org',
				walletUrl: 'https://wallet.betanet.near.org',
				helperUrl: 'https://helper.betanet.near.org',
			}
		case 'testnet':
		default:
			return {
				networkId: 'testnet',
				keyStore: new keyStores.BrowserLocalStorageKeyStore(),
				nodeUrl: 'https://rpc.testnet.near.org',
				walletUrl: 'https://wallet.testnet.near.org',
				helperUrl: 'https://helper.testnet.near.org',
				explorerUrl: 'https://explorer.testnet.near.org',
			}
	}
}
